module.exports = __webpack_public_path__ + "img/minting-grid.1a05851f.png";